export default __webpack_public_path__ + "static/scgg-f3387f40d80f73debb172dadf46a4f52.webp";